import createTableStore from "ds/components/Table/store/useTableStore";

import {
  SPACELIFT_VCS_REPO_SEARCH_COLUMN_CONFIG,
  SPACELIFT_VCS_REPO_SEARCH_COLUMNS_STORAGE_KEY,
} from "./constants";

const useSearchFilesTableStore = createTableStore({
  storageKey: SPACELIFT_VCS_REPO_SEARCH_COLUMNS_STORAGE_KEY,
  config: SPACELIFT_VCS_REPO_SEARCH_COLUMN_CONFIG,
  version: 2,
});

export default useSearchFilesTableStore;
